import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./ContentLayer.module.css";
import { checkReq, checkReqValMode } from "../../../../../utils/utils";
import RenderRectangle from "./RenderRectangle";
import { renderPositionStyle } from "../../../utils/utils";
import { isNonEmptyArray } from "../../../../../../../common/utils";

export default function ContentLayer({
	additionalData,
	height,
	metadata,
	onChangeVisibility,
	openedQuickAccess,
	tableHeight,
	width,
	page,
	selectionRectangleRef,
	hoveredContent,
	onMouseEnterBlock,
}) {
	const redressingInformation = useSelector(({ srDocument }) => srDocument.redressingInformation);
	const selectedSearch = useSelector(({ srDocument }) => srDocument.selectedSearch);
	const selectedRectangles = useSelector(({ srDocument }) => srDocument.selectedRectangles);
	const quickAccessResults = useSelector(({ srDocument }) => srDocument.quickAccessResults);
	const addRedressmentFocusActive = useSelector(({ srPdf }) => srPdf.addRedressmentFocusActive);
	const mode = useSelector(({ srDocument }) => srDocument.mode);
	const isThereAnotherTransverseFilter = useSelector(
		({ srProjectDocument }) => srProjectDocument.isThereAnotherTransverseFilter
	);
	const pageResults = useMemo(() => {
		const quickAccessPage = quickAccessResults.find((quickPage) => quickPage.page === page) || [];
		return (
			metadata?.filter((pageContent) =>
				((isNonEmptyArray(quickAccessPage?.values) && quickAccessPage?.values) || [])?.some(
					(quickInfo) => quickInfo === pageContent.informationId
				)
			) || []
		);
	}, [metadata, quickAccessResults, page]);
	const renderSearchFocus = (rec) => {
		const isReqContent = checkReq(rec);
		return (
			<>
				{isNonEmptyArray(rec?.rectangles) &&
					rec.rectangles.map((rectangle) => {
						const coordinates = renderPositionStyle(rectangle, width, height);
						const { top, height: focusHeight } = coordinates;
						const { order, contentId } = rectangle;
						return (
							<div
								key={`${contentId}-${order}`}
								alt={`${contentId}-${order}`}
								className={`${styles["search-indicator"]}`}
								data-hovered={rec.infoId === hoveredContent?.informationId}
								data-is-selected-result={selectedSearch && rec?.infoId === selectedSearch?.infoId}
								data-req-content={isReqContent && !redressingInformation}
								role="presentation"
								style={{
									top,
									left: width - 24,
									height: focusHeight,
								}}
							/>
						);
					})}
			</>
		);
	};
	return (
		<>
			{isNonEmptyArray(metadata) &&
				metadata.map((area) => {
					if (isNonEmptyArray(area?.rectangles)) {
						const { rectangle: rec, ...rest } = area;
						const { contentId, order } = area.rectangles ? area.rectangles[0] : 0;
						return (
							<RenderRectangle
								key={`${contentId}-${order}`}
								height={height}
								hoveredBlock={hoveredContent}
								isInSelection={
									(additionalData?.inSelection || []).some(
										(r) =>
											r.informationId === area.informationId || r.informationId === area.info_id
									) ||
									(selectedRectangles || []).some(
										(r) =>
											r.informationId === area.informationId || r.informationId === area.info_id
									)
								}
								isLocked={addRedressmentFocusActive}
								openedQuickAccess={openedQuickAccess}
								page={page}
								rectangle={{ ...rec, contentId, ...rest }}
								selectionRectangleRef={selectionRectangleRef}
								tableHeight={tableHeight}
								width={width}
								onChangeVisibility={onChangeVisibility}
								onEnterArea={onMouseEnterBlock}
							/>
						);
					}
					return (
						<RenderRectangle
							key={`${area.contentId}-${area.order}`}
							height={height}
							hoveredBlock={hoveredContent}
							isInSelection={
								(additionalData?.inSelection || []).some(
									(r) => r.informationId === area.informationId || r.informationId === area.info_id
								) ||
								(selectedRectangles || []).some(
									(r) => r.informationId === area.informationId || r.informationId === area.info_id
								)
							}
							isLocked={addRedressmentFocusActive}
							openedQuickAccess={openedQuickAccess}
							page={page}
							rectangle={area}
							selectionRectangleRef={selectionRectangleRef}
							tableHeight={tableHeight}
							width={width}
							onChangeVisibility={onChangeVisibility}
							onEnterArea={onMouseEnterBlock}
						/>
					);
				})}
			{isThereAnotherTransverseFilter &&
				checkReqValMode(mode) &&
				(pageResults || []).map((sd) => renderSearchFocus(sd))}
		</>
	);
}
